import React from 'react';
import { PictoProps } from './index';

export const ChevronDown = (props: PictoProps) => (
  <svg
    width={props.width || '9'}
    height={props.height || '8'}
    viewBox="0 0 9 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4.61914 8L1.15504 2L8.08324 2L4.61914 8Z" fill="#000000" />
  </svg>
);
